import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { delay } from 'rxjs';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { AssetModel, AssetWithDuplicatesModel } from 'src/app/property/models/new-asset.model';

@Component({
  selector: 'app-asset-detail-compare',
  templateUrl: './asset-detail-compare.component.html',
  styleUrls: ['./asset-detail-compare.component.scss']
})
export class AssetDetailCompareComponent implements OnInit {

  public assetDuplicateIds :any = [];
  selectedDuplicate: string;
  openAssetEditDrawer : boolean = false;
  asset : AssetModel;
  
  @Input() set assetDataID(assetId: any) {
    if (!assetId)
      return;
    this.getDuplicateAssetDetails(assetId);
  }

  constructor(private assetService: AssetService) { }

  ngOnInit(): void {
   
  }

  public onDuplicateChange(value) {   
     this.selectedDuplicate = value;
  }

  openEditDrawer(){
    this.openAssetEditDrawer =true;
  }

  closeEditAssetDrawer(){
    this.openAssetEditDrawer =false;  
    this.getDuplicateAssetDetails(this.asset.id);  
  }

  getDuplicateAssetDetails(assetId: string) {    
    
    this.assetDuplicateIds = null;
    this.selectedDuplicate = null;

    this.assetService.assetWithDuplicates(assetId).subscribe({
      next: (res) => {
        this.asset = res?.asset;
        if(res?.duplicatedAssets){
          this.assetDuplicateIds = res?.duplicatedAssets;
          this.selectedDuplicate = res?.duplicatedAssets[0];
        }
      }
    })
  }
  
}
